/**
 * Constants for mutation types
 */

// Root module mutations
export const SAVE_ACCESS_TOKEN = "SAVE_ACCESS_TOKEN";
export const SAVE_REFRESH_TOKEN = "SAVE_REFRESH_TOKEN";
export const SAVE_USER = "SAVE_USER";
export const SAVE_USER_ROLES = "SAVE_USER_ROLES";
export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";
export const SAVE_PORTS = "SAVE_PORTS";

// Shipper Module Mutations
export const UPDATE_SHIPPER_AND_CONSIGNEE_DETAILS =
  "UPDATE_SHIPPER_AND_CONSIGNEE_DETAILS";
export const UPDATE_SHIPPER_DANGEROUS_GOODS_DETAILS =
  "UPDATE_SHIPPER_DANGEROUS_GOODS_DETAILS";
export const UPDATE_ADDITIONAL_INFO_AND_DOCS =
  "UPDATE_ADDITIONAL_INFO_AND_DOCS";
export const UPDATE_CERTIFICATE_DOCUMENTS = "UPDATE_CERTIFICATE_DOCUMENTS";
export const ADD_NEW_CERTIFICATE_DOCUMENT = "ADD_NEW_CERTIFICATE_DOCUMENT";
export const SAVE_DANGEROUS_GOODS_INFO = "SAVE_DANGEROUS_GOODS_INFO";
export const ADD_NEW_DANGEROUS_GOOD = "ADD_NEW_DANGEROUS_GOOD";
export const DELETE_DANGEROUS_GOOD = "DELETE_DANGEROUS_GOOD";
export const UPDATE_FORM_DETAILS = "UPDATE_FORM_DETAILS";
export const ADD_UPLOADED_CERTIFICATE_DOCUMENT =
  "ADD_UPLOADED_CERTIFICATE_DOCUMENT";
export const DELETE_UPLOADED_CERTIFICATE_DOCUMENT =
  "DELETE_UPLOADED_CERTIFICATE_DOCUMENT";
export const RESET_CERTIFICATE_DOCUMENTS = "RESET_CERTIFICATE_DOCUMENTS";
export const UPDATE_SHIPPER_DECLARATION = "UPDATE_SHIPPER_DECLARATION";
export const UPDATE_SHIPPING_REQUEST_WITH_DATA_FROM_API =
  "UPDATE_SHIPPING_REQUEST_WITH_DATA_FROM_API";
export const RESET_STATE = "RESET_STATE";
export const RESET_SHIPPING_REQUEST = "RESET_SHIPPING_REQUEST";
export const SAVE_ALL_SHIPPER_SHIPPING_REQUESTS =
  "SAVE_ALL_SHIPPER_SHIPPING_REQUESTS";
export const SAVE_SAVED_SHIPPING_REQUESTS = "SAVE_SAVED_SHIPPING_REQUESTS";
export const SAVE_SHIPPING_REQUEST_STATISTICS =
  "SAVE_SHIPPING_REQUEST_STATISTICS";
export const CONTINUE_SAVED_SHIPPING_REQUEST =
  "CONTINUE_SAVED_SHIPPING_REQUEST";
export const SAVE_SHIPPER_SEARCH_AND_FILTER_SHIPPING_REQUESTS =
  "SAVE_SHIPPER_SEARCH_AND_FILTER_SHIPPING_REQUESTS";
export const SAVE_APPROVED_SHIPPING_REQUESTS =
  "SAVE_APPROVED_SHIPPING_REQUESTS";

// NIMASA agent module mutations
export const SAVE_SHIPPING_REQUESTS_AWAITING_PROCESSING =
  "SAVE_SHIPPING_REQUESTS_AWAITING_PROCESSING";
export const SAVE_SHIPPING_REQUESTS_PENDING_APPROVAL =
  "SAVE_SHIPPING_REQUESTS_PENDING_APPROVAL";
export const SAVE_NIMASA_SEARCH_RESULTS = "SAVE_NIMASA_SEARCH_RESULTS";
export const SAVE_SHIPPING_REQUESTS_APPROVED_APPLICATIONS =
  "SAVE_SHIPPING_REQUESTS_APPROVED_APPLICATIONS";
export const SAVE_SHIPPING_REQUESTS_DISAPPROVED_APPLICATIONS =
  "SAVE_SHIPPING_REQUESTS_DISAPPROVED_APPLICATIONS";
export const SAVE_SHIPPING_REQUESTS_FAILED_PROCESSING =
  "SAVE_SHIPPING_REQUESTS_FAILED_PROCESSING";
export const SAVE_ALL_SHIPPING_APPLICATIONS = "SAVE_ALL_SHIPPING_APPLICATIONS"
export const SAVE_PORTS_BERTHED_APPLICATIONS = "SAVE_PORTS_BERTHED_APPLICATIONS"

//Port module mutations
export const SAVE_INCOMING_SHIPPING_REQUESTS =
  "SAVE_INCOMING_SHIPPING_REQUESTS";
export const SAVE_DOCKED_SHIPPING_REQUESTS = "SAVE_DOCKED_SHIPPING_REQUESTS";
export const SAVE_DEPARTURE_SHIPPING_REQUESTS =
  "SAVE_DEPARTURE_SHIPPING_REQUESTS";
export const SAVE_PORT_SHIPPING_REQUEST_STATISTICS =
  "SAVE_PORT_SHIPPING_REQUEST_STATISTICS";
export const SAVE_ALL_PORT_SHIPPING_REQUESTS =
  "SAVE_ALL_PORT_SHIPPING_REQUESTS";
export const SAVE_DISPATCH_TRUCK_SHIPPING_REQUESTS =
  "SAVE_DISPATCH_TRUCK_SHIPPING_REQUESTS";
export const SAVE_DISPATCH_SHIP_SHIPPING_REQUESTS =
  "SAVE_DISPATCH_SHIP_SHIPPING_REQUESTS";
export const SAVE_PORT_SEARCH_AND_FILTER_REQUESTS =
  "SAVE_PORT_SEARCH_AND_FILTER_REQUESTS";

//Admin Module mutations
export const SAVE_PORT_USERS = "SAVE_PORT_USERS";
export const SAVE_NIMASA_ADMIN_USERS = "SAVE_NIMASA_ADMIN_USERS";
export const SAVE_NIMASA_USERS = "SAVE_NIMASA_USERS";
export const SAVE_NIMASA_MANAGER_USERS = "SAVE_NIMASA_MANAGER_USERS";

export const ROOT_MUTATION_TYPES = {
  SAVE_ACCESS_TOKEN,
  SAVE_REFRESH_TOKEN,
  SAVE_USER,
  SAVE_USER_ROLES,
  TOGGLE_SIDEBAR,
  SAVE_PORTS,
  RESET_STATE
};

export const SHIPPER_MUTATION_TYPES = {
  UPDATE_SHIPPER_AND_CONSIGNEE_DETAILS,
  UPDATE_SHIPPER_DANGEROUS_GOODS_DETAILS,
  UPDATE_ADDITIONAL_INFO_AND_DOCS,
  UPDATE_CERTIFICATE_DOCUMENTS,
  ADD_NEW_CERTIFICATE_DOCUMENT,
  SAVE_DANGEROUS_GOODS_INFO,
  ADD_NEW_DANGEROUS_GOOD,
  DELETE_DANGEROUS_GOOD,
  UPDATE_FORM_DETAILS,
  ADD_UPLOADED_CERTIFICATE_DOCUMENT,
  DELETE_UPLOADED_CERTIFICATE_DOCUMENT,
  RESET_CERTIFICATE_DOCUMENTS,
  UPDATE_SHIPPER_DECLARATION,
  UPDATE_SHIPPING_REQUEST_WITH_DATA_FROM_API,
  RESET_STATE,
  SAVE_DANGEROUS_GOODS_INFO,
  RESET_SHIPPING_REQUEST,
  SAVE_ALL_SHIPPER_SHIPPING_REQUESTS,
  SAVE_SAVED_SHIPPING_REQUESTS,
  SAVE_SHIPPING_REQUEST_STATISTICS,
  CONTINUE_SAVED_SHIPPING_REQUEST,
  SAVE_SHIPPER_SEARCH_AND_FILTER_SHIPPING_REQUESTS,
  SAVE_APPROVED_SHIPPING_REQUESTS
};

export const NIMASA_AGENT_MUTATION_TYPES = {
  SAVE_SHIPPING_REQUESTS_AWAITING_PROCESSING,
  SAVE_SHIPPING_REQUESTS_PENDING_APPROVAL,
  SAVE_NIMASA_SEARCH_RESULTS,
  SAVE_SHIPPING_REQUESTS_APPROVED_APPLICATIONS,
  SAVE_SHIPPING_REQUESTS_DISAPPROVED_APPLICATIONS,
  SAVE_SHIPPING_REQUESTS_FAILED_PROCESSING,
  SAVE_ALL_SHIPPING_APPLICATIONS,
  SAVE_PORTS_BERTHED_APPLICATIONS
};

export const PORT_MUTATION_TYPES = {
  SAVE_INCOMING_SHIPPING_REQUESTS,
  SAVE_DOCKED_SHIPPING_REQUESTS,
  SAVE_DEPARTURE_SHIPPING_REQUESTS,
  SAVE_PORT_SHIPPING_REQUEST_STATISTICS,
  SAVE_ALL_PORT_SHIPPING_REQUESTS,
  SAVE_DISPATCH_TRUCK_SHIPPING_REQUESTS,
  SAVE_DISPATCH_SHIP_SHIPPING_REQUESTS,
  SAVE_PORT_SEARCH_AND_FILTER_REQUESTS
};

export const ADMIN_MUTATION_TYPES = {
  SAVE_PORT_USERS,
  SAVE_NIMASA_ADMIN_USERS,
  SAVE_NIMASA_USERS,
  SAVE_NIMASA_MANAGER_USERS
};
